unit View.Api_Veiculos.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, System.StrUtils, UConstantes, UUtils,
  UPersonalizacao_Tabela.Interfaces, UPersonalizacao_Tabela;

type
  TFViewApi_VeiculosList = class(TForm)
    Api_VeiculosDataset: TXDataWebDataSet;
    Api_VeiculosDatasetid: TIntegerField;
    Api_VeiculosDatasetplaca_mercosul: TStringField;
    Api_VeiculosDatasetplaca_antiga: TStringField;
    Api_VeiculosDatasetmarca: TStringField;
    Api_VeiculosDatasetmodelo: TStringField;
    Api_VeiculosDatasetano_fabricacao: TIntegerField;
    Api_VeiculosDatasetano_modelo: TIntegerField;
    Api_VeiculosDatasetchassi: TStringField;
    Api_VeiculosDatasetcor: TStringField;
    Api_VeiculosDatasetapi: TStringField;
    Api_VeiculosDatasetretorno_api: TStringField;
    Api_VeiculosDatasetinclusao: TDateTimeField;
    Api_VeiculosDatasetalteracao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    edtRetornoApi: TEdit;
    tmrConsulta: TTimer;
    Api_VeiculosDatasetsituacao: TStringField;
    procedure WebFormCreate(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure WebDBTableControl1GetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure WebDBTableControl1GetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
    FPersonalizacaoTabela: IPersonalizacao_Tabela;

  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewApi_VeiculosList: TFViewApi_VeiculosList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewApi_VeiculosList }

procedure TFViewApi_VeiculosList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewApi_VeiculosList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewApi_VeiculosList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewApi_VeiculosList, AElementID, Result, @AfterCreate);
end;

procedure TFViewApi_VeiculosList.edSearchKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
  begin
    FGridPlugin.SetFilterText(edSearch.Text, True);
  end;
end;

procedure TFViewApi_VeiculosList.edSearchKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

procedure TFViewApi_VeiculosList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

procedure TFViewApi_VeiculosList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordRetornoApi: string;

  procedure RetornoApiButtonClick(Sender: TObject);
  var
    JSONObj: JSValue;
  begin
    JSONObj := TJSJSON.parse(RecordRetornoApi);
    edtRetornoApi.Text := TJSJSON.stringify(JSONObj, nil, 2);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Ação' then
  begin
    RecordRetornoApi := Api_VeiculosDataset.FieldByName('retorno_api').AsString;

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fa fa-list"></i>';
    Button.OnClick := @RetornoApiButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
    Button.ElementHandle.setAttribute('title', 'Ver Retorno API');
    Button.ElementHandle.setAttribute('data-bs-toggle', 'modal');
    Button.ElementHandle.setAttribute('data-bs-target', '#modal_retorno_api');
    Button.ElementHandle.setAttribute('data-test', 'btn_visualizar_retorno_api');
  end;
end;

procedure TFViewApi_VeiculosList.WebDBTableControl1GetCellClass(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['chassi', 'cor',
      'marca', 'modelo', 'situacao']) of
      0, 1, 2, 3, 4: AClassName := 'text-left';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewApi_VeiculosList.WebDBTableControl1GetCellData(Sender: TObject;
  ACol, ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
    AValue := AValue.ToUpper;

  case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['situacao']) of
    0:
    begin
      if AValue.ToUpper = 'BLACK LIST' then
        AValue := '<div class="rounded-pill text-center" style="background-color: #1C1C1C;color:white; padding-right: 5px;padding-left: 5px;">BLACK LIST</div>';
    end;
  end;
end;

procedure TFViewApi_VeiculosList.WebFormCreate(Sender: TObject);
begin
  FPersonalizacaoTabela := TPersonalizacao_Tabela.Create(Self.Name, WebDBTableControl1,
    cbPageSize);

  TUtils.SetValorDicionarioClasses('api_veiculos', 'active');
  TUtils.SetValorDicionarioClasses('apis_externas_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_apis_externas', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    Api_VeiculosDataset,
    lcPaginator,
    lbPaginationInfo
  );

  FGridPlugin.FDatasetPlugin.FOrderByPadrao := 'id desc';
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewApi_VeiculosList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.api_veiculos.list.pagination.info');
  WebDBTableControl1 := TDBTableControl.Create('view.api_veiculos.list.table');
  cbPageSize := TComboBox.Create('view.api_veiculos.list.cbPageSize');
  edSearch := TEdit.Create('view.api_veiculos.list.search');
  lcPaginator := TListControl.Create('view.api_veiculos.list.pagination');
  edtRetornoApi := TEdit.Create('edtRetornoApi');
  Api_VeiculosDataset := TXDataWebDataSet.Create(Self);
  Api_VeiculosDatasetid := TIntegerField.Create(Self);
  Api_VeiculosDatasetplaca_mercosul := TStringField.Create(Self);
  Api_VeiculosDatasetplaca_antiga := TStringField.Create(Self);
  Api_VeiculosDatasetmarca := TStringField.Create(Self);
  Api_VeiculosDatasetmodelo := TStringField.Create(Self);
  Api_VeiculosDatasetano_fabricacao := TIntegerField.Create(Self);
  Api_VeiculosDatasetano_modelo := TIntegerField.Create(Self);
  Api_VeiculosDatasetchassi := TStringField.Create(Self);
  Api_VeiculosDatasetcor := TStringField.Create(Self);
  Api_VeiculosDatasetapi := TStringField.Create(Self);
  Api_VeiculosDatasetretorno_api := TStringField.Create(Self);
  Api_VeiculosDatasetinclusao := TDateTimeField.Create(Self);
  Api_VeiculosDatasetalteracao := TDateTimeField.Create(Self);
  Api_VeiculosDatasetsituacao := TStringField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  edtRetornoApi.BeforeLoadDFMValues;
  Api_VeiculosDataset.BeforeLoadDFMValues;
  Api_VeiculosDatasetid.BeforeLoadDFMValues;
  Api_VeiculosDatasetplaca_mercosul.BeforeLoadDFMValues;
  Api_VeiculosDatasetplaca_antiga.BeforeLoadDFMValues;
  Api_VeiculosDatasetmarca.BeforeLoadDFMValues;
  Api_VeiculosDatasetmodelo.BeforeLoadDFMValues;
  Api_VeiculosDatasetano_fabricacao.BeforeLoadDFMValues;
  Api_VeiculosDatasetano_modelo.BeforeLoadDFMValues;
  Api_VeiculosDatasetchassi.BeforeLoadDFMValues;
  Api_VeiculosDatasetcor.BeforeLoadDFMValues;
  Api_VeiculosDatasetapi.BeforeLoadDFMValues;
  Api_VeiculosDatasetretorno_api.BeforeLoadDFMValues;
  Api_VeiculosDatasetinclusao.BeforeLoadDFMValues;
  Api_VeiculosDatasetalteracao.BeforeLoadDFMValues;
  Api_VeiculosDatasetsituacao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  try
    Name := 'FViewApi_VeiculosList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellData', 'WebDBTableControl1GetCellData');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellClass', 'WebDBTableControl1GetCellClass');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'A'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'C'#243'd.';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'placa_mercosul';
      Title := 'placa mercosul';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'placa_antiga';
      Title := 'placa antiga';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'marca';
      Title := 'marca';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'modelo';
      Title := 'modelo';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'situacao';
      Title := 'Situa'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'ano_fabricacao';
      Title := 'ano fabrica'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'ano_modelo';
      Title := 'ano modelo';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'chassi';
      Title := 'chassi';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cor';
      Title := 'cor';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'api';
      Title := 'api';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclus'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'altera'#231#227'o';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    edtRetornoApi.SetParentComponent(Self);
    edtRetornoApi.Name := 'edtRetornoApi';
    edtRetornoApi.Left := 8;
    edtRetornoApi.Top := 422;
    edtRetornoApi.Width := 250;
    edtRetornoApi.Height := 22;
    edtRetornoApi.ChildOrder := 31;
    edtRetornoApi.Enabled := False;
    edtRetornoApi.HeightPercent := 100.000000000000000000;
    edtRetornoApi.Text := 'edtRetornoApi';
    edtRetornoApi.WidthPercent := 100.000000000000000000;
    Api_VeiculosDataset.SetParentComponent(Self);
    Api_VeiculosDataset.Name := 'Api_VeiculosDataset';
    Api_VeiculosDataset.EntitySetName := 'Api_Veiculos';
    Api_VeiculosDataset.Connection := DMConnection.ApiConnection;
    Api_VeiculosDataset.Left := 72;
    Api_VeiculosDataset.Top := 144;
    Api_VeiculosDatasetid.SetParentComponent(Api_VeiculosDataset);
    Api_VeiculosDatasetid.Name := 'Api_VeiculosDatasetid';
    Api_VeiculosDatasetid.FieldName := 'id';
    Api_VeiculosDatasetid.Required := True;
    Api_VeiculosDatasetplaca_mercosul.SetParentComponent(Api_VeiculosDataset);
    Api_VeiculosDatasetplaca_mercosul.Name := 'Api_VeiculosDatasetplaca_mercosul';
    Api_VeiculosDatasetplaca_mercosul.FieldName := 'placa_mercosul';
    Api_VeiculosDatasetplaca_mercosul.Size := 255;
    Api_VeiculosDatasetplaca_antiga.SetParentComponent(Api_VeiculosDataset);
    Api_VeiculosDatasetplaca_antiga.Name := 'Api_VeiculosDatasetplaca_antiga';
    Api_VeiculosDatasetplaca_antiga.FieldName := 'placa_antiga';
    Api_VeiculosDatasetplaca_antiga.Size := 255;
    Api_VeiculosDatasetmarca.SetParentComponent(Api_VeiculosDataset);
    Api_VeiculosDatasetmarca.Name := 'Api_VeiculosDatasetmarca';
    Api_VeiculosDatasetmarca.FieldName := 'marca';
    Api_VeiculosDatasetmarca.Size := 255;
    Api_VeiculosDatasetmodelo.SetParentComponent(Api_VeiculosDataset);
    Api_VeiculosDatasetmodelo.Name := 'Api_VeiculosDatasetmodelo';
    Api_VeiculosDatasetmodelo.FieldName := 'modelo';
    Api_VeiculosDatasetmodelo.Size := 255;
    Api_VeiculosDatasetano_fabricacao.SetParentComponent(Api_VeiculosDataset);
    Api_VeiculosDatasetano_fabricacao.Name := 'Api_VeiculosDatasetano_fabricacao';
    Api_VeiculosDatasetano_fabricacao.FieldName := 'ano_fabricacao';
    Api_VeiculosDatasetano_modelo.SetParentComponent(Api_VeiculosDataset);
    Api_VeiculosDatasetano_modelo.Name := 'Api_VeiculosDatasetano_modelo';
    Api_VeiculosDatasetano_modelo.FieldName := 'ano_modelo';
    Api_VeiculosDatasetchassi.SetParentComponent(Api_VeiculosDataset);
    Api_VeiculosDatasetchassi.Name := 'Api_VeiculosDatasetchassi';
    Api_VeiculosDatasetchassi.FieldName := 'chassi';
    Api_VeiculosDatasetchassi.Size := 255;
    Api_VeiculosDatasetcor.SetParentComponent(Api_VeiculosDataset);
    Api_VeiculosDatasetcor.Name := 'Api_VeiculosDatasetcor';
    Api_VeiculosDatasetcor.FieldName := 'cor';
    Api_VeiculosDatasetcor.Size := 255;
    Api_VeiculosDatasetapi.SetParentComponent(Api_VeiculosDataset);
    Api_VeiculosDatasetapi.Name := 'Api_VeiculosDatasetapi';
    Api_VeiculosDatasetapi.FieldName := 'api';
    Api_VeiculosDatasetapi.Size := 255;
    Api_VeiculosDatasetretorno_api.SetParentComponent(Api_VeiculosDataset);
    Api_VeiculosDatasetretorno_api.Name := 'Api_VeiculosDatasetretorno_api';
    Api_VeiculosDatasetretorno_api.FieldName := 'retorno_api';
    Api_VeiculosDatasetretorno_api.Size := 255;
    Api_VeiculosDatasetinclusao.SetParentComponent(Api_VeiculosDataset);
    Api_VeiculosDatasetinclusao.Name := 'Api_VeiculosDatasetinclusao';
    Api_VeiculosDatasetinclusao.FieldName := 'inclusao';
    Api_VeiculosDatasetinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Api_VeiculosDatasetalteracao.SetParentComponent(Api_VeiculosDataset);
    Api_VeiculosDatasetalteracao.Name := 'Api_VeiculosDatasetalteracao';
    Api_VeiculosDatasetalteracao.FieldName := 'alteracao';
    Api_VeiculosDatasetalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Api_VeiculosDatasetsituacao.SetParentComponent(Api_VeiculosDataset);
    Api_VeiculosDatasetsituacao.Name := 'Api_VeiculosDatasetsituacao';
    Api_VeiculosDatasetsituacao.FieldName := 'situacao';
    Api_VeiculosDatasetsituacao.Size := 255;
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Api_VeiculosDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 616;
    tmrConsulta.Top := 344;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    edtRetornoApi.AfterLoadDFMValues;
    Api_VeiculosDataset.AfterLoadDFMValues;
    Api_VeiculosDatasetid.AfterLoadDFMValues;
    Api_VeiculosDatasetplaca_mercosul.AfterLoadDFMValues;
    Api_VeiculosDatasetplaca_antiga.AfterLoadDFMValues;
    Api_VeiculosDatasetmarca.AfterLoadDFMValues;
    Api_VeiculosDatasetmodelo.AfterLoadDFMValues;
    Api_VeiculosDatasetano_fabricacao.AfterLoadDFMValues;
    Api_VeiculosDatasetano_modelo.AfterLoadDFMValues;
    Api_VeiculosDatasetchassi.AfterLoadDFMValues;
    Api_VeiculosDatasetcor.AfterLoadDFMValues;
    Api_VeiculosDatasetapi.AfterLoadDFMValues;
    Api_VeiculosDatasetretorno_api.AfterLoadDFMValues;
    Api_VeiculosDatasetinclusao.AfterLoadDFMValues;
    Api_VeiculosDatasetalteracao.AfterLoadDFMValues;
    Api_VeiculosDatasetsituacao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
  end;
end;

end.
